const es419 = {
  'modal.close': 'Cerrar',
  'session_expired.title': 'La sesión ha vencido',
  'tokenizationForm.payment-terms.text1':
    'Autorizo a Flywire a almacenar y cobrar automáticamente en mi tarjeta de débito/crédito en nombre de {{recipientName}}. Leí, entiendo y acepto',
  'tokenizationForm.general-terms.link2': 'y política de privacidad de Flywire',
  'tokenizationForm.general-terms.link-joint': ' y ',
  'tokenizationForm.general-terms.link1': 'Condiciones de uso de Flywire',
  'tokenizationForm.payment-terms.link':
    'las condiciones de uso de Flywire para pagos automatizados',
  'tokenizationForm.labels.cvvTooltip':
    '3 dígitos en la parte posterior de la tarjeta o 4 en la parte frontal',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': 'Fecha de vencimiento (MM/AA)',
  'tokenizationForm.labels.cardNumber': 'Número de tarjeta',
  'tokenizationForm.labels.phone': 'Número de teléfono',
  'tokenizationForm.labels.upopPhone':
    'Ingresa el número de celular vinculado a esta tarjeta bancaria',
  'tokenizationForm.labels.zip': 'Código postal',
  'tokenizationForm.labels.address': 'Dirección',
  'cardsForm.labels.state': 'Estado o provincia',
  'tokenizationForm.labels.country': 'País o región',
  'tokenizationForm.labels.city': 'Ciudad',
  'tokenizationForm.labels.email': 'Correo electrónico',
  'tokenizationForm.labels.lastName': 'Apellido',
  'tokenizationForm.labels.firstName': 'Nombre',
  'cardsForm.title': 'Información del titular de la tarjeta',
  'success.title': 'Tus fondos están en camino',
  'success.title.info':
    'Espera de 2 a 3 días hábiles para que los fondos lleguen a su destino.\nRecibirás un correo electrónico cuando los fondos se hayan entregado.',
  'bankAccountForm.hints.generic': 'Ejemplo: {{label}}',
  'bankAccountForm.hints.account_number':
    'La longitud del número de cuenta bancaria debe ser de entre 1 y 17 caracteres',
  'bankAccountForm.hints.routing_number':
    'La longitud del número de enrutamiento debe ser de 9 dígitos',
  'bankAccountForm.labels.accountZipCode': 'Código postal',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'Código BIC',
  'bankAccountForm.labels.accountNumber': 'Número de cuenta',
  'bankAccountForm.labels.accountSortCode': 'Sort code',
  'bankAccountForm.labels.accountRoutingNumber': 'Código de identificación bancaria',
  'bankAccountForm.labels.accountType': 'Tipo de cuenta',
  'bankAccountForm.labels.eftProviderWidnow':
    'Te dirigiremos a nuestra plataforma de procesamiento para completar el pago. Una vez hecho esto, serás redirigido de nuevo a esta página',
  'bankAccountForm.labels.termsFlywire':
    "He leído, entiendo y acepto las <a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/terms/' target='_blank' rel='noopener noreferrer' data-testid='termsOfUseLink'>Condiciones de uso</a> y la <a class='fw-underline fw-text-primary-600' href='https://www.flywire.com/privacy/' target='_blank' data-testid='privacyPolicyLink' rel='noopener noreferrer'>Política de privacidad</a> de Flywire",
  'bankAccountForm.labels.termsDirectDebit':
    'Confirmo que soy el titular de esta cuenta y el único firmante necesario para autorizar este débito directo',
  'bankAccountForm.labels.termsEft':
    "He leído, entiendo y acepto el <a class='fw-underline fw-text-primary-600' href='https://opu.myonplanu.com/pdf/pad-agreement.pdf' target='_blank' rel='noopener noreferrer'>Acuerdo de débito preautorizado</a>",
  'bankAccountForm.labels.city': 'Ciudad',
  'bankAccountForm.labels.country': 'País o región',
  'bankAccountForm.labels.selectCountry': 'Selecciona un país o región',
  'bankAccountForm.title': 'Información del titular de la cuenta',
  'failure.tryAgain': 'Intentar de nuevo',
  'failure.title': 'Transacción no realizada',
  'failure.connectivity.message':
    'La operación falló. Esto podría deberse a un problema de conectividad.',
  'failure.message':
    'Error en la transacción. Esto podría deberse a problemas de conectividad. Inténtalo de nuevo. Si el problema continúa, prueba con otro método de pago o comunícate con tu banco',
  'sessionExpired.text': 'La sesión ha vencido',
  'LoadingError.title': 'Ocurrió un error',
  'LoadingError.message': 'Ocurrió un error al cargar el formulario',
  'tokenizationForm.errors.noPaymentOptionsAvailable':
    'No hay métodos de pago disponibles para el país o la región seleccionados',
  'offerError.noOptions.card':
    'El tipo de tarjeta seleccionado no es compatible. Usa otro tipo de tarjeta.',
  'offerError.noOptions.bank':
    'La cuenta bancaria seleccionada no es compatible. Usa otra cuenta bancaria.',
  'offerError.noOptions.other':
    'El método de pago seleccionado no es compatible. Usa otro método de pago.',
  'bankAccountForm.labels.accountHolderType.personal': 'Cuenta personal',
  'bankAccountForm.labels.accountHolderType.business': 'Cuenta de empresa',
  'bankAccountForm.labels.name': 'Nombre',
  'bankAccountForm.labels.businessName': 'Nombre de la empresa',
  'bankAccountForm.labels.surname': 'Apellido',
  'bankAccountForm.labels.phone': 'Número de teléfono',
  'bankAccountForm.labels.email': 'Correo electrónico',
  'bankAccountForm.labels.zip': 'Código postal',
  'bankAccountForm.labels.accountAddress': 'Dirección',
  'bankAccountForm.labels.address': 'Dirección',
  'bankAccountForm.errors.dynamicFields': '{{field}} no válido',
  'bankAccountForm.labels.saveButton': 'Guardar',
  'bankAccountForm.labels.nextButton': 'Siguiente',
  'bankAccountForm.labels.payButton': 'Pagar',
  'bankAccountForm.errors.cardNumber': 'Número de tarjeta no válido',
  'tokenizationForm.errors.cardNumber': 'Número de tarjeta no válido',
  'tokenizationForm.errors.cvv': 'Número CVV no válido',
  'bankAccountForm.errors.cvv': 'Número CVV no válido',
  'tokenizationForm.errors.unsupportedCardTypes': 'Solo se admiten {{acceptedCardsList}}',
  'tokenizationForm.errors.unsupportedCardType': 'Solo se admite {{acceptedCard}}',
  'tokenizationForm.errors.cardType.and': 'y',
  'tokenizationForm.errors.name': 'Nombre no válido',
  'tokenizationForm.errors.email': 'Correo electrónico no válido',
  'tokenizationForm.errors.country': 'País o región no válidos',
  'tokenizationForm.errors.state': 'Estado o provincia no válido',
  'tokenizationForm.errors.city': 'Ciudad no válida',
  'tokenizationForm.errors.address': 'Dirección no válida',
  'tokenizationForm.errors.addressIsPoBox':
    'No aceptamos apartados postales en el campo de dirección.',
  'tokenizationForm.errors.onlyLetterOrNumbers': 'Los únicos caracteres permitidos son A-Z y 0-9',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol':
    'Los únicos caracteres permitidos son A-Z, 0-9 y «/, -»',
  'tokenizationForm.errors.zip': 'Código postal no válido',
  'tokenizationForm.errors.expiryDate': 'Fecha de vencimiento no válida',
  'bankAccountForm.errors.expiryDate': 'Fecha de vencimiento no válida',
  'tokenizationForm.errors.surname': 'Apellido no válido',
  'tokenizationForm.errors.phone': 'Número de teléfono no válido',
  'tokenizationForm.errors.length': 'El campo es demasiado largo (el máximo es de 256 caracteres)',
  'tokenizationForm.errors.required.field': 'Campo obligatorio',
  'bankAccountForm.errors.name': 'Nombre no válido',
  'bankAccountForm.errors.name.maxSizeExceeded':
    'El nombre es demasiado largo (el máximo es de 140 caracteres)',
  'form.errors.name.maxSizeExceeded':
    'El nombre es demasiado largo (el máximo es de {{limit}} caracteres)',
  'form.errors.surname.maxSizeExceeded':
    'El apellido es demasiado largo (el máximo es de {{limit}} caracteres)',
  'form.errors.business_name.maxSizeExceeded':
    'El nombre de la empresa es demasiado largo (el máximo es de {{limit}} caracteres)',
  'form.errors.city.maxSizeExceeded':
    'La ciudad es demasiado larga (el máximo es de {{limit}} caracteres)',
  'form.errors.address.maxSizeExceeded':
    'La dirección es demasiado larga (el máximo es de {{limit}} caracteres)',
  'form.errors.date.wrongDate': 'Valor de selector de fecha no válido',
  'bankAccountForm.errors.business_name': 'Nombre de empresa no válido',
  'bankAccountForm.errors.business_name.maxSizeExceeded':
    'El nombre de la empresa es demasiado largo (el máximo es de 140 caracteres)',
  'bankAccountForm.errors.surname': 'Apellido no válido',
  'bankAccountForm.errors.surname.maxSizeExceeded':
    'El apellido es demasiado largo (el máximo es de 140 caracteres)',
  'bankAccountForm.errors.country': 'País o región no válidos',
  'bankAccountForm.errors.address': 'Dirección no válida',
  'bankAccountForm.errors.address.maxSizeExceeded':
    'La dirección es demasiado larga (el máximo es de 256 caracteres)',
  'bankAccountForm.errors.city': 'Ciudad no válida',
  'bankAccountForm.errors.city.maxSizeExceeded':
    'La ciudad es demasiado larga (el máximo es de 256 caracteres)',
  'bankAccountForm.errors.email': 'Correo electrónico no válido',
  'bankAccountForm.errors.state': 'Estado o provincia no válido',
  'bankAccountForm.errors.iban': 'IBAN no válido',
  'bankAccountForm.errors.bic': 'Código BIC no válido',
  'bankAccountForm.errors.accountnumber': 'Número de cuenta no válido',
  'bankAccountForm.errors.sortcode': 'Código de identificación no válido',
  'bankAccountForm.errors.account_type': 'Tipo de cuenta no válido',
  'bankAccountForm.errors.addressIsPoBox':
    'No aceptamos apartados postales en el campo de dirección.',
  'bankAccountForm.errors.onlyLetterOrNumbers': 'Los únicos caracteres permitidos son A-Z y 0-9',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': 'Los caracteres válidos son: A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': 'Código postal no válido',
  'bankAccountForm.errors.phone': 'Número de teléfono no válido',
  'bankAccountForm.errors.ach_account_number': 'Número de cuenta no válido',
  'bankAccountForm.errors.routing_number': 'Número de enrutamiento no válido',
  'bankAccountForm.errors.offer':
    'No hay métodos de pago disponibles. Si tienes una cuenta bancaria en otro país/región, selecciona ese país/región o elige otra tarjeta e inténtalo de nuevo. Si eso no resuelve el problema, comunícate con {{recipientName}}',
  'binLookUp.unableToFindCard.message':
    'Error de tarjeta. Revisa los datos de la tarjeta que ingresaste o prueba con otra tarjeta.',
  'binLookUp.warning.message': 'No podemos verificar tu tarjeta',
  'confirmationPage.labels.edit': 'Editar',
  'confirmationPage.labels.confirm': 'Confirmar',
  'confirmationPage.labels.title': 'Revisar la información del mandato de débito directo',
  'confirmationPage.labels.typeOfPayment': 'Tipo de pago',
  'confirmationPage.labels.paymentRecipient': 'Destinatario del pago',
  'confirmationPage.labels.typeOfPayment.oneOff': 'Único',
  'confirmationPage.labels.typeOfPayment.recurring': 'Recurrente',
  'confirmationPage.labels.directDebitInformation': 'Información sobre el débito directo',
  'confirmationPage.labels.directDebitInformation.title': 'Instrucciones para el banco',
  'confirmationPage.labels.directDebitInformation.creditor': 'Acreedor',
  'confirmationPage.labels.directDebitInformation.creditorId': 'ID del acreedor',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement':
    'Nombre en tu estado de cuenta',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'ID de usuario del servicio',
  'confirmationPage.labels.directDebitInformation.address': 'Dirección de Flywire',
  'confirmationPage.labels.directDebitInformation.originator': 'Originador',
  'confirmationPage.labels.directDebitInformation.originatorId': 'ID del originador',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Dirección del originador',
  'confirmationPage.labels.bankAccountInformation': 'Información de la cuenta bancaria',
  'confirmationPage.labels.bankAccountInformation.name': 'Nombre',
  'confirmationPage.labels.bankAccountInformation.iban': 'Número IBAN',
  'confirmationPage.labels.bankAccountInformation.email': 'Correo electrónico',
  'confirmationPage.labels.bankAccountInformation.country': 'País o región',
  'confirmationPage.labels.bankAccountInformation.state': 'Estado o provincia',
  'confirmationPage.labels.bankAccountInformation.city': 'Ciudad',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'Código BIC',
  'confirmationPage.labels.bankAccountInformation.accountNumber': 'Número de cuenta',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'Sort code',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': 'Número de cuenta',
  'confirmationPage.labels.bankAccountInformation.routingNumber':
    'Código de identificación bancaria',
  'confirmationPage.labels.bankAccountInformation.accountType': 'Tipo de cuenta',
  'confirmationPage.labels.paymentInformation': 'Información de pago',
  'confirmationPage.labels.paymentInformation.amount': 'Monto',
  'confirmationPage.labels.changeAccountEft': 'Cambiar los datos de la cuenta bancaria',
  'confirmationPage.labels.editPayerEft': 'Editar los detalles del pagador',
  'confirmationPage.labels.useAccountEft': 'Usar la cuenta terminada en **** {{lastFour}}',
  'confirmationPage.labels.bankLinkSuccessMessage': 'Cuenta bancaria vinculada correctamente',
  'confirmationPage.labels.termsSepa':
    'Al firmar este mandato, autorizas a (A) FLYWIRE EUROPE UAB a enviar instrucciones a tu banco para cargar tu cuenta y (B) a tu banco a efectuar dichos cargos en tu cuenta según las instrucciones de FLYWIRE EUROPE UAB. Se te notificará al menos tres días antes del cobro.',
  'confirmationPage.labels.termsBacs':
    'Da instrucciones a tu banco para que pague a Flywire Payments Limited los débitos directos de la cuenta indicada en esta instrucción, conforme a las salvaguardas de la Garantía de Débito Directo. Entiendo que esta instrucción puede permanecer en Flywire Payments Limited y, de ser así, los datos se transferirán electrónicamente a mi banco o sociedad hipotecaria.',
  'confirmationPage.labels.termsAch':
    '\n     Al hacer clic en «Confirmar», afirmas que tienes la debida autorización y por la presente autorizas a Flywire en nombre del destinatario especificado \n(«Beneficiario») a cargar en la cuenta bancaria proporcionada por ti cualquier monto adeudado por cargos derivados del uso de los servicios \n     y/o compra de productos del Beneficiario y, si es necesario, a corregir cargos erróneos, de conformidad con los términos del Beneficiario, hasta que esta \n     autorización sea revocada. En el caso de que se rechace una transacción ACH por fondos insuficientes, entiendo que se me cobrará una \n     tarifa de NSF y que Flywire puede, a su discreción, intentar procesar el cargo de nuevo.\n     ',
  'confirmationPage.labels.termsAch2':
    '\n     Si utilizas o adquieres periódicamente productos y/o servicios adicionales del Beneficiario, de conformidad con las condiciones del Beneficiario, autorizas a \nFlywire, en nombre del Beneficiario, a efectuar periódicamente cargos en la cuenta bancaria facilitada por ti. Los pagos que queden fuera del débito\n     autorizado anteriormente solo se cargarán después de obtener tu autorización a través de tu cuenta, o bien a través de una contraseña, código u otro\n     equivalente de firma.\n     ',
  'confirmationPage.labels.termsAch3':
    '\n     Puedes revocar esta autorización en cualquier momento comunicándote con el Beneficiario. Tu revocación debe recibirse al menos [10 días hábiles] \n      antes del siguiente pago previsto.\n    ',
  'confirmationPage.labels.print': 'Imprimir acuerdo',
  'amountPanel.labels.amountFromLabel': 'Pagarás',
  'amountPanel.labels.surchargeFeeInfo': 'tarifa de la tarjeta incluida',
  'amountPanel.labels.serviceFeeInfo': 'tarifa de servicio incluida',
  'amountPanel.labels.serviceFeePercentageInfo':
    'Tarifa de servicio {{percentage}} (mín. {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': 'Tarifa de servicio {{percentage}}',
  'amountPanel.labels.whyThisFee': '¿Por qué se aplica esta tarifa?',
  'amountPanel.labels.currencyChangeWarning':
    'Se cambió la divisa para que coincida con la de tu tarjeta',
  'amountPanel.labels.amountToLabel': '{{recipientName}} recibirá',
  'amountPanel.labels.editCurrencySelection': 'Editar selección de divisa',
  'amountPanel.labels.discountApplied': '{{amount}} de descuento aplicado',
  'currencyInfoBanner.labels.currencyInfo':
    'Se te cobrará en <b>{{code}} ({{symbol}})</b> en tus próximos pagos.',
  'currencyInfoBanner.error.offerNotFound': 'Opciones de pago no disponibles.',
  AX: 'Islas Åland',
  AD: 'Andorra',
  BG: 'Bulgaria',
  AT: 'Austria',
  BE: 'Bélgica',
  HR: 'Croacia',
  CY: 'Chipre',
  CZ: 'Chequia',
  DK: 'Dinamarca',
  EE: 'Estonia',
  FI: 'Finlandia',
  FR: 'Francia',
  GP: 'Guadalupe',
  DE: 'Alemania',
  GR: 'Grecia',
  HU: 'Hungría',
  IS: 'Islandia',
  IE: 'Irlanda',
  VA: 'Ciudad del Vaticano',
  IT: 'Italia',
  LI: 'Liechtenstein',
  LT: 'Lituania',
  LU: 'Luxemburgo',
  YT: 'Mayotte',
  MT: 'Malta',
  MQ: 'Martinica',
  ES: 'España',
  NO: 'Noruega',
  NL: 'Países Bajos',
  PL: 'Polonia',
  PT: 'Portugal',
  SE: 'Suecia',
  RE: 'Reunión',
  RO: 'Rumania',
  CH: 'Suiza',
  BL: 'San Bartolomé',
  GB: 'Reino Unido',
  MC: 'Mónaco',
  MF: 'San Martín',
  PM: 'San Pedro y Miquelón',
  SM: 'San Marino',
  SK: 'Eslovaquia',
  SI: 'Eslovenia',
  GF: 'Guayana Francesa',
  LV: 'Letonia',
  CA: 'Canadá',
  US: 'Estados Unidos',
  'inlineDialogConfirmation.labels.title': 'Se necesita confirmación: cancelar proceso',
  'inlineDialogConfirmation.labels.body': '¿Seguro que quieres cancelar este proceso?',
  'inlineDialogConfirmation.labels.closeButton': 'No',
  'inlineDialogConfirmation.labels.confirmButton': 'Sí',
  'priceBreakDown.price.toggle.button': 'Desglose de precios',
  'priceBreakDown.fx.toggle.button': 'Desglose de cambio de divisas',
  'priceBreakDown.fees': 'Tarifas',
  'priceBreakDown.service_fees': 'Tarifa de servicio',
  'priceBreakDown.card_fees': 'Tarifa de la tarjeta',
  'priceBreakDown.exchange.rate': 'Tipo de cambio de divisas',
  'priceBreakDown.markup.rate': 'Margen sobre el tipo de cambio del BCE',
  'priceBreakDown.discount': 'Descuento',
  'priceBreakDown.discount.coupon': 'Descuento ({{code}})',
  'priceBreakDown.original_amount': 'Monto original',
  'priceBreakDown.total': 'Total',
  'acceptProposedOfferBanner.textInfo':
    'Esta tarjeta no es válida. Haz clic en «Aceptar» para continuar con los métodos de pago admitidos o ',
  'acceptProposedOfferBanner.textInfoWithoutChangeCard':
    'Esta tarjeta no es válida. Haz clic en «Aceptar» para continuar con los métodos de pago admitidos.',
  'acceptProposedOfferBanner.link.option': 'Cambiar tarjeta',
  'acceptProposedOfferBanner.labels.accept': 'Aceptar',
  'chooseCurrencyBanner.title': 'Seleccionar divisa',
  'chooseCurrencyBanner.message':
    'La divisa de tu tarjeta no coincide con la del país de facturación. Selecciona la divisa que quieras usar para esta transacción:',
  'banner.offer.validation.message': 'Tienes que elegir una acción para continuar.',
  'instructions.offline.amount.label': 'Monto a pagar',
  'instructions.offline.reference.label': 'Referencia de pago (Payment ID)',
  'instructions.offline.paymentId.label': 'Referencia de pago',
  'instructions.offline.paymentReferenceMissing': 'Falta la referencia de pago',
  'instructions.offline.missing.title': 'No fue posible generar las instrucciones de pago',
  'instructions.offline.missing.message':
    'Inténtalo de nuevo. Si el problema continúa, prueba con otro método de pago o comunícate con tu banco.',
  'instructions.offline.title': 'Instrucciones de pago',
  'instructions.offline.understand':
    'Entiendo que debo iniciar una transferencia desde mi banco.<br />Haz clic aquí para cerrar.',
  'instructions.offline.download.button': 'Descargar instrucciones para la transferencia bancaria',
  'instructions.offline.howToBankTransfer': '¿Cómo hacer una transferencia bancaria?',
  'instructions.offline.howToBankTransfer.modal.title': 'Cómo completar la transferencia bancaria',
  'instructions.offline.howToBankTransfer.modal.intro':
    'A continuación encontrarás diferentes opciones para completar la transferencia bancaria:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle': 'Banca en línea/banca móvil',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription':
    'Si tienes una cuenta bancaria en línea o la aplicación móvil de tu banco, puedes acceder fácilmente a tu cuenta y hacer la transferencia tú mismo.',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle':
    'Visita en persona la sucursal del banco',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription':
    'Si vas personalmente a tu sucursal bancaria local, puedes proporcionar a tu banco los datos de la cuenta que figuran en las instrucciones y realizar la transferencia.',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'Transferencia telefónica',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription':
    'También puedes llamar a tu banco y autorizarlo para que lleve a cabo la transacción en tu nombre.',
  'instructions.offline.referenceWarning':
    'Debes incluir esta referencia para que podamos identificar el pago.',
  'instructions.offline.dueDateLabel': 'Transfiere los fondos antes de:',
  'instructions.offline.processingTime':
    'Flywire recibirá los fondos entre <strong>2 y 3 días hábiles</strong> después de que inicies la transferencia',
  'elementsInstructions.qr.description': 'Escanea el código QR para completar el pago',
  'elementsInstructions.qr.payid.description':
    'Abre tu app bancaria y envía el pago al PayID que aparece abajo. Esta dirección está asignada exclusivamente a tu cuenta; los pagos se asocian automáticamente.',
  'elementsInstructions.qr.scan': 'O escanea con la cámara de tu teléfono',
  'elementsInstructions.qr.waitingForPayment': 'Esperando que se complete el pago',
  'elementsInstructions.externalAction.generic': 'Completa el pago para continuar.',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone':
    'Se envió una solicitud de pago de M-Pesa a tu teléfono.\nCompleta el pago para continuar.',
  'elementsInstructions.redirect.title': 'Completa tu pago',
  'elementsInstructions.redirect.description':
    'Te llevaremos a la plataforma de procesamiento del socio para completar este pago. Una vez que termines, volverás a esta página.',
  'elementsInstructions.redirect.button': 'Realizar el pago',
  'documentCollector.collapsibleTitle': 'Subir documentación',
  'documentCollector.uploadingDocument': 'Subiendo documento',
  'documentCollector.deleteFile': 'Eliminar {{fileName}}',
  'documentCollector.deletingFile': 'Eliminando {{fileName}}',
  'documentCollector.moreInfoModal': 'Más información',
  'documentCollector.errorsModal': 'Advertencias del documento',
  'documentCollector.documentList': 'Lista de documentos',
  'documentCollector.upload': 'Subir',
  'documentCollector.errorBlockLabel': 'Advertencias del documento',
  'documentCollector.reUpload': 'Volver a cargar',
  'documentCollector.errorsFoundOne': '{{count}} advertencia encontrada',
  'documentCollector.errorsFoundOther': '{{count}} advertencias encontradas',
  'documentCollector.validationNote':
    '<b>¡Archivo subido correctamente!</b> Nuestro análisis automatizado ha detectado posibles problemas. Si tu documento contiene toda la información necesaria, ignora este aviso.',
  'documentCollector.antivirus': 'Análisis de archivos antivirus',
  'documentCollector.antivirusStep': 'Análisis de archivos antivirus 1/2',
  'documentCollector.verifyingStep': 'Verificación de documentos 2/2',
  'documentCollector.invalidFile':
    'Se detectó un archivo no válido. El archivo puede estar protegido con contraseña o cifrado. Verifícalo e inténtalo de nuevo.',
  'documentCollector.moreInfo': 'Más información',
  'documentCollector.required': 'se requiere',
  'documentCollector.review': 'Revisar',
  'documentCollector.acceptedFileTypes':
    'Tipos de archivo aceptados: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>',
  'documentCollector.maxFileSize': 'Tamaño máximo de archivo: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.acceptedFileAndFileSize':
    'Tipos de archivo aceptados: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>. Tamaño máximo de archivo: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.docVerifyError.missingInfo':
    'Verifica que el documento contenga toda la información solicitada.',
  'documentCollector.docVerifyError.documentTypeError':
    'Esto no parece un/a {{documentType}}. Revisa los requisitos y sube un nuevo archivo si es necesario.',
  'documentCollector.docVerifyError.documentIdentificationTypeError':
    'El documento subido no parece un {{documentType}}, que es el tipo de identificación que has seleccionado para este pago. Compruébalo y súbelo de nuevo si es necesario.',
  'documentCollector.docVerifyError.documentType.errorNote':
    '<b>Nota</b>: el envío de documentos incorrectos puede causar retrasos en la tramitación del pago. Si tus documentos son válidos, ignora este aviso.',
  'documentCollector.duplicateFile':
    'Se detectó un documento duplicado. Sube un archivo diferente para cada uno.',
  'oneOff.savePaymentMethod.label': 'Guardar este método de pago para pagos futuros',
  'lrs.transaction.title': 'Transacción',
  'lrs.transaction.date': 'Fecha',
  'lrs.transaction.amount': 'Monto',
  'lrs.transaction.amountHint': 'Monto en moneda extranjera',
  'lrs.transaction.adBranch': 'Nombre y dirección de la sucursal autorizada',
  'lrs.transaction.add': 'Agregar más transacciones',
  'lrs.signatureModal.title': 'Firmar el documento',
  'lrs.signatureModal.tab.draw': 'Firmar',
  'lrs.signatureModal.tab.upload': 'Cargar la firma',
  'lrs.signatureModal.draw.text':
    'Firma con el dedo o el mouse en el espacio indicado a continuación para aceptar el documento.',
  'lrs.signatureModal.legalAlert':
    'Una firma incorrecta invalidará todo el proceso LRS. Asegúrate de firmar con la <b>firma del titular del PAN</b>. Se enviará una copia del documento al correo electrónico del pagador que se nos indicó, para consulta futura. Tipos de archivos aceptados: <b>PNG</b>, <b>JPG</b>.',
  'lrs.signatureModal.draw.clear': 'Borrar',
  'lrs.signatureModal.upload.label': 'Sube una versión en formato de imagen de tu firma',
  'lrs.signatureModal.upload.input': 'Cargar la firma',
  'lrs.signatureModal.upload.remove': 'Eliminar',
  'lrs.signatureModal.upload.hint':
    'Tipos de archivos aceptados: <b>PNG</b>, <b>JPG</b>. Tamaño máximo del archivo: <b>8 MB</b>',
  'lrs.signatureModal.upload.typeError':
    'Tipo de archivo no compatible. Sube un archivo PNG o JPG.',
  'lrs.signatureModal.upload.sizeError': 'El archivo debe ser inferior a 8 MB',
  'lrs.signatureModal.upload.readError': 'No se pudo leer el archivo. Inténtalo de nuevo.',
  'lrs.signatureModal.confirm': 'Aceptar y enviar',
  'lrs.signatureModal.previewError':
    'Ocurrió un error al generar la vista previa. Inténtalo de nuevo.',
  'lrs.signatureModal.uploadError': 'Ocurrió un error al enviar. Inténtalo de nuevo.',
  'lrs.previewLink.label': 'Vista previa del documento',
  'lrs.documents.continueButton': 'Continúa con el envío del formulario LRS',
  'lrs.form.declaration':
    "En virtud del programa de liberalización de pagos (LRS), el gobierno de la India y el Banco de Reserva de la India (RBI) a partir de ahora exigen un formulario de declaración LRS (nombre completo «Declaración A2 cum LRS») para poder transferir fondos al extranjero. Es OBLIGATORIO presentar la declaración LRS antes de iniciar la transferencia bancaria, de lo contrario, la tramitación del pago podría sufrir demoras. Para obtener información sobre cómo completar este paso, haz clic <a href='https://help.flywire.com/hc/es/articles/360012963774' target='_blank'>aquí</a>.",
  'lrs.form.bankAccountAndStudentInfo.title': 'Cuenta bancaria e información del estudiante',
  'lrs.form.bankAccountAndStudentInfo.text':
    'Especifica la cuenta bancaria desde la que se transferirán los fondos. Si has recibido un préstamo educativo y los fondos se desembolsarán desde la cuenta de dicho préstamo, proporciona el número de cuenta del préstamo. No se aceptan transferencias desde cuentas NRO/NRE. Para la ID de estudiante, puedes usar tu ID de estudiante, el ID de solicitud o el número de referencia.',
  'lrs.form.details.title':
    'Información de las transacciones internacionales realizadas en el año fiscal actual',
  'lrs.form.details.text':
    'Proporciona los detalles de cualquier transacción en divisa extranjera que hayas realizado durante el año fiscal actual (<b>abril {{startYear}} - marzo {{endYear}}</b>). Déjalo en blanco si no has hecho ninguna.',
  'lrs.form.bankAccountNumber': 'Número de cuenta bancaria',
  'lrs.form.studentFullName': 'Nombre completo del estudiante',
  'lrs.form.studentId': 'Identificación de estudiante',
  'lrs.form.required': 'se requiere',
  'lrs.form.signAndSubmit': 'Firma y envía el formulario LRS',
  'lrs.title': 'Subir documentación y enviar el formulario LRS',
  'lrs.description':
    'Verás las instrucciones de pago de la transferencia bancaria una vez completado este paso.',
  'lrs.tabs.documents': '1. Sube los documentos',
  'lrs.tabs.form': '2. Envía el formulario LRS',
  'recipientFields.requiredField': '(*) campo obligatorio',
  'paymentMethodSelector.loading': 'Cargando métodos de pago...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'Acepta tarjetas de débito y crédito',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'Acepta tarjetas de débito',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'Acepta tarjetas de crédito',
  'paymentMethodSelector.cards.surchargeWarning':
    'Pueden aplicarse cargos adicionales según el tipo de tarjeta y el país emisor.',
  'paymentMethodSelector.subtitle.default': 'Pagar con {{methodName}}',
  'paymentMethodSelector.subtitle.google_pay':
    'Paga con la billetera de Google Pay que tienes guardada',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID o Face ID — solo en Safari',
  'paymentMethodSelector.subtitle.paypal': 'Paga con tu cuenta de PayPal',
  'paymentMethodSelector.subtitle.wechat': 'Pagar con WeChat — disponible en China continental',
  'paymentMethodSelector.subtitle.alipay': 'Pagar con Alipay',
  'paymentMethodSelector.subtitle.trustly': 'Pago mediante banca abierta'
} as const;
export { es419 };
